import { Injectable } from '@angular/core';
import { VALIDATION_CONSTANTS, VALIDATION_MESSAGES } from '../constants/validation.constants';

export interface ValidationResult {
  isValid: boolean;
  message?: string;
}

@Injectable()
export class NumberValidationService {
  
  validateNumber(number: string): ValidationResult {
    const trimmedNumber = number ? number.trim() : '';
    
    if (!trimmedNumber) {
      return { isValid: false, message: VALIDATION_MESSAGES.NUMBER_REQUIRED };
    }

    if (trimmedNumber.length < VALIDATION_CONSTANTS.MIN_NUMBER_LENGTH) {
      return { isValid: false, message: VALIDATION_MESSAGES.NUMBER_MIN_LENGTH };
    }

    if (!VALIDATION_CONSTANTS.NUMBER_PATTERN.test(trimmedNumber)) {
      return { isValid: false, message: VALIDATION_MESSAGES.NUMBER_INVALID_CHARACTERS };
    }

    return { isValid: true };
  }
}


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/services/number-validation.service.ts